import React, { PureComponent } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import i18n from "i18next";
import set from "lodash/fp/set";

import { getCustomerSelectionsSelector, getUnitOfMeasurementsSelector } from "../../selectors/selectors";
import { getCustomers, getUnitOfMeasurements, setSessionPreferences, updateUserMetadata } from "../../actions";
import { getUserName } from "./../../helpers/userHelpers";
import Panel from "./../Layout/Panel/Panel";
import PanelHeader from "./../Layout/Panel/PanelHeader";
import PanelSubNav from "./../Layout/Panel/PanelSubNav";
import UserPreferencesForm from "./UserPreferencesForm";
import UserPreferencesProfile from "./UserPreferencesProfile";
import ViewTypes from "./ViewTypes";

class UserPreferencesPage extends PureComponent {
  static propTypes = {
    getCustomers: PropTypes.func.isRequired,
    getUnitOfMeasurements: PropTypes.func.isRequired,
    setSessionPreferences: PropTypes.func.isRequired,
    updateUserMetadata: PropTypes.func.isRequired,
    customersSelections: PropTypes.array,
    isMobile: PropTypes.bool,
    sessionPreferences: PropTypes.object,
    unitOfMeasurements: PropTypes.array,
    user: PropTypes.object,
    userMetadata: PropTypes.object
  };

  static defaultProps = {
    customersSelections: [],
    sessionPreferences: {},
    isMobile: false,
    unitOfMeasurements: [],
    user: {},
    userMetadata: {}
  };

  state = {
    selectedView: ViewTypes.Preferences
  };

  componentDidMount() {
    this.props.getUnitOfMeasurements();
    this.props.getCustomers();
  }

  handleChangeMetadata = (fieldName, fieldValue, shouldSetSessionPreferences) => {
    const updatedMetadata = set(fieldName, fieldValue, this.props.userMetadata);
    this.updateUserMetadata(updatedMetadata);

    if (shouldSetSessionPreferences) {
      const updatedSessionPreferences = set(fieldName, fieldValue, this.props.sessionPreferences);
      this.props.setSessionPreferences(updatedSessionPreferences);
    }
  };

  updateUserMetadata = userMetadata => this.props.updateUserMetadata({ ...this.props.userMetadata, ...userMetadata }, this.props.user.sub);

  handleSelectedView = selectedView => this.setState({ selectedView });

  subNavs = [
    {
      key: ViewTypes.Profile,
      label: i18n.t("userPreferences.profile"),
      onClick: this.handleSelectedView
    },
    {
      key: ViewTypes.Preferences,
      label: i18n.t("userPreferences.preferences"),
      onClick: this.handleSelectedView
    }
  ];

  render() {
    const userInfos = { ...this.props.user, ...this.props.userMetadata };
    const userProfile = { userName: getUserName(this.props.user), email: userInfos.email };

    return (
      <Panel className="user-preferences">
        <PanelHeader id={i18n.t("userPreferences.mySettings")} isMobile={this.props.isMobile} />
        <PanelSubNav subNavs={this.subNavs} activeSubNav={this.state.selectedView} />

        {this.state.selectedView === ViewTypes.Profile && <UserPreferencesProfile initialValues={userProfile} />}
        {this.state.selectedView === ViewTypes.Preferences && (
          <UserPreferencesForm
            customersSelections={this.props.customersSelections}
            initialValues={userInfos}
            onChangeMetadata={this.handleChangeMetadata}
            unitOfMeasurements={this.props.unitOfMeasurements}
            userMetadata={this.props.userMetadata}
          />
        )}
      </Panel>
    );
  }
}

const mapStateToProps = state => {
  return {
    customersSelections: getCustomerSelectionsSelector(state),
    isMobile: state.app.isMobile,
    sessionPreferences: state.app.sessionPreferences,
    user: state.app.user,
    userMetadata: state.app.userMetadata,
    unitOfMeasurements: getUnitOfMeasurementsSelector(state)
  };
};

export default connect(
  mapStateToProps,
  { getCustomers, getUnitOfMeasurements, setSessionPreferences, updateUserMetadata }
)(UserPreferencesPage);



// WEBPACK FOOTER //
// ./src/components/UserPreferences/UserPreferences.js